export const FEATURE_KEYS = {
  DASHBOARD: 1,
  INVENTORY: 2,
  SALES: 3,
  SALES_HISTORY: 65,
  FUNDS: 4,
  PRODUCTS: 5,
  DEBTS: 6,
  CUSTOMERS: 7,
  SUPPLIERS: 8,
  PROFITS: 9,
  SETTINGS: 10,
  TOP_UP: 11,
  EXPENSES: 12,
  RENEW_STOCK: 13,
  ADD_PRODUCT_TO_STOCK: 14,
  STOCK: 15,
  BRANCHS: 16,
  PHARMACISTS: 17,
  MEDICATIONS: 18,
  PRESCRIPTIONS: 19,
  PHARMACY_SALES: 20,
  PHARMACY_DASHBOARD_V1: 21,
  PHARMACY_BATCHES: 22,
  REPORTS: 23,
  PHARMACY_PROCUREMENT: 24,
  PHARMACY_BRANCHES: 25,
  CONSOLIDATED_INVENTORY: 26,
  PHARMACY_REPORTS: 27,
  PROCUREMENT: 28,
  LOW_STOCK_REPORT: 29,
  LOANS: 30,
  POS_V2: 31,
  WHOLESALE: 32,
  PURCHASE_ORDERS: 33,
  DELIVERY_NOTES: 34,
  PHARMACY_DASHBOARD: 35,
  PATIENTS: 36,
  BAR_DASHBOARD: 37,
  COMPTOIRS: 38,
  BAR_STOCK: 39,
  BAR_MOVEMENTS: 40,
  BAR_POS: 41,
  BAR_RECIPES: 42,
  BAR_TABS: 43,
  BAR_SHIFTS: 44,
  BAR_ANALYTICS: 45,
  CATEGORIES: 46,
  ARCHIVED_PRODUCTS: 47,
  INVENTORY_MANAGEMENT: 48,
  PHARMACY_POS: 49,
  DISPENSING: 50,
  STOCK_MOVEMENTS: 51,
  BAR_MENUS: 52,
  AUDIT_LOGS: 53,
  RETAIL_DASHBOARD: 54,
  RETAIL_INVENTORY: 55,
  RETAIL_SUPPLIERS: 56,
  RETAIL_REPORTS: 57,
  OWNER_DASHBOARD: 58,
  RESTAURANT_DASHBOARD: 59,
  RESTAURANT_TABLES: 60,
  RESTAURANT_RESERVATIONS: 61,
  RESTAURANT_KITCHEN: 62,
  RESTAURANT_REPORTS: 63,
  RESTAURANT_TABLE_TERMS: 64,

  // Hospital & Clinical
  HOSPITAL_DASHBOARD: 80,
  CLINICAL_QUEUE: 81,
  TRIAGE: 82,
  CONSULTATION: 83,

  // Granular Action Permissions
  ADD_PRODUCT: 70,
  EDIT_PRODUCT: 71,
  ADD_STOCK: 72,
  EDIT_STOCK: 73,
  VIEW_COST_PRICE: 74,
  CONTROL_PRICES: 75,
  VIEW_RETAIL_PRICE: 76,
  MANAGE_STOCK_DETAILS: 77,

  // Hospital & Clinical Expansion
  HOSPITAL_HR: 84,
  HOSPITAL_PAYROLL: 85,
  HOSPITAL_MANAGEMENT: 86,
  HOSPITAL_WARDS: 87,
  HOSPITAL_LABS: 88,

  // General HRM & Payroll
  HRM: 100,
  PAYROLL: 101,
  POS_DISCOUNT: 95,
  SALES_ANALYTICS: 96,
  FINANCIAL_ANALYTICS: 97,
  STORE_FULFILLMENT: 98,

  // Domain Microservices (Grocery, Clothing, Shoe, Hardware, Jewelry)
  GROCERY_DASHBOARD: 110,
  GROCERY_PLU_SCALE: 111,
  GROCERY_INVENTORY: 147,
  GROCERY_EXPIRIES: 148,
  GROCERY_SPOILAGE: 149,
  GROCERY_REPORTS: 150,
  GROCERY_POS: 151,
  CLOTHING_DASHBOARD: 112,
  CLOTHING_MATRIX: 113,
  SHOE_DASHBOARD: 114,
  SHOE_SIZE_CONVERTER: 115,
  SHOE_POS: 120,
  SHOE_PREPACKS: 121,
  SHOE_AUDITS: 122,
  SHOE_MISMATCHED: 123,
  SHOE_CARE: 124,
  SHOE_LABELS: 125,
  SHOE_CATALOG: 126,
  HARDWARE_DASHBOARD: 116,
  HARDWARE_TOOL_RENTAL: 117,
  JEWELRY_DASHBOARD: 118,
  JEWELRY_VAULT: 119,
  JEWELRY_POS: 127,
  JEWELRY_TRADE_INS: 128,
  JEWELRY_SPOT_RATES: 129,
  JEWELRY_CERTIFICATES: 130,
  JEWELRY_REPORTS: 135,

  // Mobile Money & Agency Banking
  MOBILE_MONEY_DASHBOARD: 1,
  MOBILE_MONEY_POS_OPS: 110,
  MOBILE_MONEY_SHIFT_RECONCILIATION: 111,
  MOBILE_MONEY_FLOAT_MGMT: 112,
  MOBILE_MONEY_FINANCIAL_ANALYTICS: 113,
  MOBILE_MONEY_EXPENSES_OUTFLOWS: 114,
  MOBILE_MONEY_TELLER_MGMT: 115,
  MOBILE_MONEY_SETTINGS_COMMISSIONS: 116,
  MOBILE_MONEY_POS: 131,
  MOBILE_MONEY_FLOATS: 132,
  MOBILE_MONEY_LEDGER: 133,
  MOBILE_MONEY_RECONCILIATION: 134,

  // Hotel & Hospitality PMS Microservice
  HOTEL_DASHBOARD: 140,
  HOTEL_ROOMS: 141,
  HOTEL_RESERVATIONS: 142,
  HOTEL_HOUSEKEEPING: 143,
  HOTEL_FOLIOS: 144,
  HOTEL_REPORTS: 145,
  HOTEL_GUESTS: 146,

  // Coffee Shop Microservice
  COFFEE_SHOP_DASHBOARD: 160,
  COFFEE_SHOP_POS: 161,
  COFFEE_SHOP_ORDERS: 162,
  COFFEE_SHOP_RECIPES: 163,
  COFFEE_SHOP_MODIFIERS: 164,
  COFFEE_SHOP_SHIFTS: 165,
  COFFEE_SHOP_SPILLAGE: 166,
  COFFEE_SHOP_LOYALTY: 167,

  // 7 New Domain Microservices (Dashboards & Granular Modules)
  REAL_ESTATE_DASHBOARD: 170,
  REAL_ESTATE_PROPERTIES: 201,
  REAL_ESTATE_UNITS: 202,
  REAL_ESTATE_RENT: 203,
  REAL_ESTATE_MAINTENANCE: 204,

  BARBERSHOP_DASHBOARD: 171,
  BARBERSHOP_POS: 205,
  BARBERSHOP_STATIONS: 206,
  BARBERSHOP_CATALOG: 207,

  SPA_DASHBOARD: 172,
  SPA_BOOKINGS: 208,
  SPA_ROOMS: 209,
  SPA_MEMBERSHIPS: 210,

  TAILORING_DASHBOARD: 173,
  TAILORING_ORDERS: 211,
  TAILORING_MEASUREMENTS: 212,
  TAILORING_FABRICS: 213,

  PROFESSIONAL_SERVICES_DASHBOARD: 174,
  PROFESSIONAL_SERVICES_ENGAGEMENTS: 214,
  PROFESSIONAL_SERVICES_TIMESHEETS: 215,
  PROFESSIONAL_SERVICES_RETAINERS: 216,

  SALON_DASHBOARD: 175,
  SALON_APPOINTMENTS: 217,
  SALON_FORMULAS: 218,
  SALON_CHAIRS: 219,

  CAR_RENTAL_DASHBOARD: 176,
  CAR_RENTAL_FLEET: 220,
  CAR_RENTAL_AGREEMENTS: 221,
  CAR_RENTAL_DAMAGES: 222,
} as const;
